module.exports = __webpack_public_path__ + "static/media/arrow-icon-full-bright-red-right.b3d0cf43.svg";